const SELECT_TYPES = {
    WITH_LABEL: "with-label",
    WITHOUT_LABEL: "without-label",
};

export default SELECT_TYPES;
